var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4065",
    "data-name": "Group 4065",
    transform: "translate(584 -1873)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12532",
    "data-name": "Rectangle 12532",
    width: 30,
    height: 30,
    transform: "translate(-584 1873)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "users-icon",
    transform: "translate(-580 1876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038",
    transform: "translate(5.659 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    d: "M8.8,8.8a2.8,2.8,0,0,1,5.591,0A2.8,2.8,0,0,1,8.8,8.8Zm2.8,4.659C7.3,13.455,6,16.53,6,16.53v1.584H17.182V16.53S15.877,13.455,11.591,13.455Z",
    transform: "translate(-6 -6)",
    fill: "#7a7a7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4041",
    "data-name": "Group 4041",
    transform: "translate(14.698 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039",
    transform: "translate(0.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16779",
    "data-name": "Ellipse 16779",
    cx: 2.33,
    cy: 2.33,
    r: 2.33,
    fill: "#7a7a7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4040",
    "data-name": "Group 4040",
    transform: "translate(0 6.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    d: "M18.309,13a4.338,4.338,0,0,0-2.609.745,5.75,5.75,0,0,1,2.982,2.982v.093H22.5V15.609A4.335,4.335,0,0,0,18.309,13Z",
    transform: "translate(-15.7 -13)",
    fill: "#7a7a7a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044",
    transform: "translate(14.698 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042",
    transform: "translate(0.28)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16780",
    "data-name": "Ellipse 16780",
    cx: 2.33,
    cy: 2.33,
    r: 2.33,
    fill: "#7a7a7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4043",
    "data-name": "Group 4043",
    transform: "translate(0 6.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M18.309,13a4.338,4.338,0,0,0-2.609.745,5.75,5.75,0,0,1,2.982,2.982v.093H22.5V15.609A4.335,4.335,0,0,0,18.309,13Z",
    transform: "translate(-15.7 -13)",
    fill: "#7a7a7a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    transform: "translate(1 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045",
    transform: "translate(1.864)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16781",
    "data-name": "Ellipse 16781",
    cx: 2.33,
    cy: 2.33,
    r: 2.33,
    fill: "#7a7a7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046",
    transform: "translate(0 6.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M5.193,13a4.338,4.338,0,0,1,2.609.745A5.75,5.75,0,0,0,4.82,16.727v.093H1V15.609A4.335,4.335,0,0,1,5.193,13Z",
    transform: "translate(-1 -13)",
    fill: "#7a7a7a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipIcon);
export default __webpack_public_path__ + "static/media/membership-icon.723c6595e7529d79105e534ed6c8cac4.svg";
export { ForwardRef as ReactComponent };